const text = ['<p>Virtual + In-Store Appointments. <a href="https://bario-neal.com/appointments/">Book Today.</a></p>', '<p>Free Domestic Shipping + Shop Our <a href="https://bario-neal.com/product-category/featured/sale-featured/">Sale.</a></p>', '<p>Shop our <a href="https://bario-neal.com/product-category/engagement/cluster-rings-engagement/">Cluster Rings</a> + <a href="https://bario-neal.com/product-category/wedding/classic-bands/">Classic Bands</a></p>', '<p>Read our <a href="https://bario-neal.com/reviews/">Customer Reviews</a></p>', 'Free 2-day shipping for domestic orders valued over $500.'];
let counter = 0;
const elem = document.getElementById("top-bar");
const inst = setInterval(change, 5000);

function change() {
  elem.innerHTML = text[counter];
  counter++;
  if (counter >= text.length) {
    counter = 0;

  }
}